export default __webpack_public_path__ + "static/media/card2.92c991e3.jpg";